export class MedicalRecords
{
        allergies:string;
        medications:string;
        immunizations:number[];
        medicalNotes: string;
        bloodGroup: string;    
}